import ScreenQuickAccessCard from './ScreenQuickAccessCard';
export default ScreenQuickAccessCard;
